import type { SigningField } from '../types/fields';

export interface FloatingToolbarVisibilityInput {
  /** Text-based selected field on this page, or null when none qualifies. */
  field: SigningField | null;
  inlineEditingFieldId: string | null;
  /** Raw dismiss id from scroll; may be cleared when selection changes. */
  scrollDismissedFieldId: string | null;
}

/**
 * Pure visibility gate for the canvas floating format toolbar.
 * Parent supplies the already-filtered text field candidate for this page.
 */
export function shouldShowFloatingToolbar(input: FloatingToolbarVisibilityInput): boolean {
  const { field, inlineEditingFieldId, scrollDismissedFieldId } = input;
  if (!field) return false;
  if (inlineEditingFieldId === field.id) return false;
  if (scrollDismissedFieldId === field.id) return false;
  return true;
}

/**
 * When the user changes selection (including re-select after deselect), scroll-dismiss
 * for the newly selected field is cleared synchronously — no useEffect lag.
 */
export function effectiveScrollDismissedFieldId(
  selectedFieldId: string | null,
  scrollDismissedFieldId: string | null,
  previousSelectedFieldId: string | null,
): string | null {
  if (!selectedFieldId) return null;
  if (selectedFieldId !== previousSelectedFieldId && scrollDismissedFieldId === selectedFieldId) {
    return null;
  }
  return scrollDismissedFieldId;
}